import { loc } from "../../../core/utils"
import { withPackContext } from "../../hoc/withPackContext"
import { withTunnelDataContext } from "../../hoc/withTunnelDataContext"
import React from "react"
import { Button, Col, Row } from "react-bootstrap"
import Modal from "react-bootstrap/Modal"

const InsuranceModal = ({ showModal, changePackContext, onSetStep }) => {
  return (
    <Modal show={showModal} backdrop="static" keyboard={false} className="modal-info">
      <Modal.Body>
        <i className="fas fa-info-circle"></i>
        <h3>{loc`You have not chosen an insurance option`}</h3>
        <p>{loc`Be aware that in case of breakage or theft, you will have to pay for repairs to the product or its replacement. Remember to protect your device for peace of mind, as the breakdown guarantee does not cover breakage or theft.`}</p>
        <p>
          <small>{loc`*see general conditions in the insurance notice`}</small>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Row className="justify-content-md-center">
          <Col md={6} lg={6}>
            <Button variant="outline-primary" onClick={() => changePackContext({ showModal: false })}>
              Annuler
            </Button>
          </Col>
          <Col md={6} lg={6}>
            <Button id="confirm-button" variant="success" onClick={() => onSetStep()}>
              Confirmer
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}

export default withTunnelDataContext(withPackContext(InsuranceModal))
